import StockObjectiveDetails from "./StockObjectiveDetails"

class StockObjective {
    constructor({ stockId, stockObjectiveDetails, primaryObjective }) {
        this._stockId = stockId
        this._stockObjectiveDetails = new StockObjectiveDetails({ ...stockObjectiveDetails })
        this._primaryObjective = primaryObjective
    }

    get stockId() { return this._stockId }
    get stockObjectiveDetails() { return this._stockObjectiveDetails }
    get primaryObjective() { return this._primaryObjective }

    get primaryObjectiveValue() {
        let value = 0;
        switch (this._primaryObjective) {
            case 'totalTargetedValue':
                value = this._stockObjectiveDetails.totalTargetedValue
                break;
            case 'totalInvestmentTargetedAmount':
                value = this._stockObjectiveDetails.totalInvestmentTargetedAmount
                break;
            case 'totalTargetedShareCount':
                value = this._stockObjectiveDetails.totalTargetedShareCount
                break;
            case 'percentageOfTotalInvestmentValue':
                value = this._stockObjectiveDetails.percentageOfTotalInvestmentValue
                break;
        }
        return value;
    }
}

export default StockObjective